export default __webpack_public_path__ + "static/media/gallery03.71c8841e.jpg";